import React, { useEffect, useState } from 'react';
import './page5.css';
import { useNavigate, useLocation } from 'react-router-dom';

function NewBatsman() {
  const [wicketType, setWicketType] = useState('');
  const [newBatsmanName, setNewBatsmanName] = useState('');
  const [battingTeam, setBattingTeam] = useState([]);
  const [helpingPlayers, setHelpingPlayers] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const match_id = localStorage.getItem('match_id');
  const striker = location.state?.striker;
  const nonstriker = location.state?.nonstriker;
  const nextpage = location.state?.nextpage;

  const outOver = localStorage.getItem("out_over");
  const outBowler = localStorage.getItem("out_bowler");

  useEffect(() => {
    fetchBattingTeam();
  }, []);

  const fetchBattingTeam = async () => {
    try {
      const res = await fetch(`https://nammateam.onrender.com/batting/${match_id}`);
      if (!res.ok) throw new Error("Failed to fetch batting team");
      const data = await res.json();
      setBattingTeam(data);
    } catch (err) {
      console.error('Error fetching batting team:', err);
    }
  };

  const renderHelperFields = () => {
    if (wicketType.toLowerCase().includes("catch")) {
      return (
        <div className="nb-section">
          <label className="nb-label">Fielder Name</label>
          <input
            type="text"
            className="nb-input"
            value={helpingPlayers[0] || ""}
            onChange={e => setHelpingPlayers([e.target.value])}
          />
        </div>
      );
    } else if (wicketType.toLowerCase().includes("run out")) {
      return (
        <>
          <div className="nb-section">
            <label className="nb-label">Run Out Player 1</label>
            <input
              type="text"
              className="nb-input"
              value={helpingPlayers[0] || ""}
              onChange={e => setHelpingPlayers([e.target.value, helpingPlayers[1] || ""])}
            />
          </div>
          <div className="nb-section">
            <label className="nb-label">Run Out Player 2 (optional)</label>
            <input
              type="text"
              className="nb-input"
              value={helpingPlayers[1] || ""}
              onChange={e => setHelpingPlayers([helpingPlayers[0], e.target.value])}
            />
          </div>
        </>
      );
    }
    return null;
  };

  const handleAddBatsman = async () => {
    if (!wicketType.trim() || !newBatsmanName.trim()) {
      alert('Please select a wicket type and enter the new batsman name.');
      return;
    }

    try {
      // Find the out player
      let outBatsman = striker;
      let whoGotOut = "striker";

      if (wicketType.toLowerCase().includes("non-striker")) {
        outBatsman = nonstriker;
        whoGotOut = "non-striker";
      }

      const outPlayer = battingTeam.find(player =>
        player.name?.trim().toLowerCase() === outBatsman?.name?.trim().toLowerCase() &&
        Number(player.position) === Number(outBatsman?.position)
      );

      let outHelpValue = null;
      if (wicketType.toLowerCase().includes("catch") || wicketType.toLowerCase().includes("run out")) {
        outHelpValue = helpingPlayers.filter(p => p).join(', ');
      }

      const nextPosition = battingTeam.length + 1;

      // 👉 Use fetch instead of axios
      const res = await fetch(`https://nammateam.onrender.com/process-wicket`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          match_id,
          out_player_id: outPlayer.player_id,
          out_batsman_name: outPlayer.name,
          out_over: outOver,
          out_type: wicketType,
          out_bowler: outBowler,
          out_help: outHelpValue,
          new_batsman_name: newBatsmanName,
          new_position: nextPosition
        })
      });

      if (!res.ok) throw new Error("Failed to process wicket");

      // Local storage updates
      localStorage.setItem("whoGotOut", whoGotOut);
      if (whoGotOut === "non-striker") {
        localStorage.setItem("sname", striker.name);
        localStorage.setItem("sposition", striker.position);
        localStorage.setItem("nname", newBatsmanName);
        localStorage.setItem("nposition", nextPosition);
      } else {
        localStorage.setItem("sname", newBatsmanName);
        localStorage.setItem("sposition", nextPosition);
      }

      alert('New batsman added successfully');
      navigate(nextpage === "/newbowler" ? '/newbowler' : '/live');

    } catch (err) {
      console.error('Error processing wicket:', err);
      alert('Failed to process wicket. Try again.');
    }
  };

  return (
    <div className="nb-container">
      <h2 className="nb-heading">New Batsman Entry</h2>

      <div className="nb-section">
        <label className="nb-label">Wicket Type</label>
        <select
          className="nb-select"
          value={wicketType}
          onChange={e => setWicketType(e.target.value)}
        >
          <option value="">Select Wicket Type</option>
          <option>Bowled</option>
          <option>LBW</option>
          <option>Hit Wicket</option>
          <option>Catch</option>
          <option>Run Out (Striker)</option>
          <option>Run Out (Non-Striker)</option>
          <option>Stumped</option>
          <option>Caught & Bowled</option>
          <option>Handled the Ball</option>
          <option>Hit the Ball Twice</option>
          <option>Timed Out</option>
          <option>Obstructing the Field</option>
        </select>
      </div>

      {renderHelperFields()}

      <div className="nb-section">
        <label className="nb-label">New Batsman Name</label>
        <input
          type="text"
          className="nb-input"
          placeholder="Enter player name"
          value={newBatsmanName}
          onChange={e => setNewBatsmanName(e.target.value)}
        />
      </div>

      <div className="nb-section nb-buttons">
        <button className="nb-btn nb-confirm" onClick={handleAddBatsman}>Confirm</button>
        <button className="nb-btn nb-cancel" onClick={() => navigate('/live')}>Cancel</button>
      </div>
    </div>
  );
}

export default NewBatsman;
